export default __webpack_public_path__ + "static/media/guide-6.1a601c87.png";